import React from 'react';
import SelectSingle from './SelectSingle';
import referencesService, { Pitch } from '../../services/references';
import useReferenceList from './useReferenceList';
import Progress from './Progress';
import { useSnackbar } from 'notistack';

export type { Pitch };

interface Props {
  value: Pick<Pitch, 'id'> | undefined;
  onChange: (pitch: Pitch) => void;
}

const pitchSort = (a: Pitch, b: Pitch) => {
  return a.name.localeCompare(b.name);
};

const SelectSinglePitch: React.FunctionComponent<Props> = (props) => {
  const { data, error, loading } = useReferenceList('pitches', referencesService.getPitches);
  const { enqueueSnackbar } = useSnackbar();

  if (error) {
    enqueueSnackbar('Failed to load pitches', { variant: 'error', autoHideDuration: 3000 });
  }

  if (loading) {
    return <Progress />;
  }

  const onChange = (value: Pitch | undefined) => {
    if (value) props.onChange(value);
  };

  const pitches = (data || []).slice().sort(pitchSort);

  const selected = pitches.find((p) => p.id === (props.value && props.value.id));

  return (
    <SelectSingle<Pitch>
      selected={selected}
      onChange={onChange}
      data={pitches}
      isClearable={false}
      label="Pitch"
      placeholder="Select pitch"
      optionValue={(option) => String(option.id)}
      optionLabel={(option) => option.name}
    />
  );
};

export default SelectSinglePitch;
